import { render, staticRenderFns } from "./VirHomePart1.vue?vue&type=template&id=96df4086&scoped=true&"
import script from "./VirHomePart1.vue?vue&type=script&lang=js&"
export * from "./VirHomePart1.vue?vue&type=script&lang=js&"
import style0 from "./VirHomePart1.vue?vue&type=style&index=0&id=96df4086&prod&scoped=true&lang=scss&"
import style1 from "./VirHomePart1.vue?vue&type=style&index=1&id=96df4086&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96df4086",
  null
  
)

export default component.exports